import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../../redux/store";
import endpoints from "../../../api/endpoints";
import axiosInstance from "../../../api/axiosInstance";

interface ArticleTarifState {
  loading: boolean;
  error: string | null;
  netpri: number | null;
}

const initialState: ArticleTarifState = {
  loading: false,
  error: null,
  netpri: null,
};

interface ArticleTarifInput {
  codeClient: string | undefined;
  codeArticle: string ;
  siteVente: string | undefined;
  siteExpedition: string | undefined;
  quantite: number;
  unite: string;
  devise: string;
  dateCommande: string;
}

interface ArticleTarifResponse {
  netpri: number;
}

export const fetchArticleTarif = createAsyncThunk(
  "articleTarif/fetchArticleTarif",
  async (data: ArticleTarifInput , {getState}) => {
    const state = getState() as RootState;

    const language = state.languageSlice.language;
    
    const response = await axiosInstance.post(
      endpoints.articles.articleTarif,
      data,
      {
        headers: {
          "Accept-Language": language,
        },
      }
    );   
    return response.data;
  }
);

const articleTarifSlice = createSlice({
  name: "articleTarif",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArticleTarif.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchArticleTarif.fulfilled, (state, action: PayloadAction<ArticleTarifResponse>) => {
        state.loading = false;
        state.netpri = action.payload.netpri;
      })
      .addCase(fetchArticleTarif.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch article tariff";
      });
  },
});

export default articleTarifSlice.reducer;
